import { getSuccessfullVerificationMsg } from "@/utils/msgs"
import { Chat } from "../chat"

export class ChatViewModel {
    chat: Chat

    constructor(chat: Chat) {
        this.chat = chat
    }
    
    get mainPhotoUrl(): string | null {
        if (!this.chat)
            return null
        const photos =
            this.chat.profile.photos
        if (photos.length)
            return photos[0].main_url
        return null
    }

    get successVerificationTitle(): string {
        const profile =
            this.chat.profile
        return getSuccessfullVerificationMsg(profile.public_name, profile.gender)
    }

    isPremium(): boolean {
        if (!this.chat)
            return false
        return this
            .chat
            .profile
            .is_paid
            === true
    }
}
